var _circle, _rect, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 114,
    viewBox: "0 0 106 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 64,
    r: 47,
    fill: "#FFE3E3",
    stroke: "#9C4C4C",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1130_1874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 40,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 40,
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1130_1874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.616 70.92C48.592 70.92 47.7173 70.5787 46.992 69.896C46.2667 69.1707 45.8827 68.296 45.84 67.272L44.88 41.928C44.8373 40.9467 45.1573 40.0933 45.84 39.368C46.5227 38.6427 47.3547 38.28 48.336 38.28H51.792C52.7733 38.28 53.6053 38.6427 54.288 39.368C54.9707 40.0933 55.2907 40.9467 55.248 41.928L54.288 67.272C54.2453 68.296 53.8613 69.1707 53.136 69.896C52.4107 70.5787 51.536 70.92 50.512 70.92H49.616ZM51.152 76.04C52.1333 76.04 52.9653 76.4027 53.648 77.128C54.3733 77.8533 54.736 78.7067 54.736 79.688V81.352C54.736 82.3333 54.3733 83.1867 53.648 83.912C52.9653 84.6373 52.1333 85 51.152 85H48.976C47.9947 85 47.1413 84.6373 46.416 83.912C45.7333 83.1867 45.392 82.3333 45.392 81.352V79.688C45.392 78.7067 45.7333 77.8533 46.416 77.128C47.1413 76.4027 47.9947 76.04 48.976 76.04H51.152Z",
    fill: "#D38D8D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0001 11.9379L89.2446 2",
    stroke: "#9C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9942 19.3672L103.868 13.8398",
    stroke: "#9C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7865422596976be5e410fd9e55c85d05.svg";
export { ForwardRef as ReactComponent };